import { useCallback, useEffect, useMemo, useRef, useState } from "preact/compat";
import RGL from 'react-grid-layout'
import { getRandomItems } from "../../utils/misc";
import WidgetFactory from "../Screen/Widget/WidgetFactory";
import 'react-grid-layout/css/styles.css'

const ReactGridLayout = RGL

const RenderReactGrid = (props) => {
  const { flow, initTime, isReverse, isHidden, preview_data, handleEvent, company, visibleState, displayAnimation, selectedAnimation, isUniq, updateArea } = props;
  const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);

  useEffect(() => {
    const updateSize = () => {
      if (windowSize[0] !== window.innerWidth || windowSize[1] !== window.innerHeight);
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  if (visibleState === 2) {
    return null;
  }

  const layoutRef = useRef(null);
  const frameCount = useMemo(() => (!Number.isNaN(parseInt(flow.endOn?.frame_count)) && parseInt(flow.endOn?.frame_count) > 0) ? parseInt(flow.endOn?.frame_count) : flow.areas[0]?.data?.length, [flow]);

  const areas = useMemo(() => {
    if (frameCount >= flow.areas?.length) {
      return flow.areas;
    }

    return getRandomItems(flow.areas, frameCount);
  }, [frameCount]);

  const generateDOM = useCallback(() => areas.map((area) => (
    <div key={area.slug} style={{ overflow: 'hidden' }}>
      <WidgetFactory initTime={initTime} updateArea={updateArea} isUniq={isUniq} preview_data={preview_data} company={company} flow={flow} area={area} onEvent={handleEvent} isHidden={visibleState === 1} />
    </div>
  )), [areas, initTime, updateArea, isUniq, preview_data, company, handleEvent, visibleState]);

  const styleDuration = displayAnimation ? {} : { animation: 'none' }

  if (! flow) {
    return null
  }

  return (
    <div className={visibleState === 1 ? selectedAnimation.classNext : selectedAnimation.classActive} style={styleDuration}>
      <div style={styleDuration}>
        {visibleState === selectedAnimation.conditionState && selectedAnimation.children ? (
          selectedAnimation.children(styleDuration, flow.mainColor, flow.secondaryColor)
        ) : null}
        <ReactGridLayout
          {...props}
          className='layout'
          style={styleDuration}
          rowHeight={(isReverse ? windowSize[0] : windowSize[1]) / flow.nbRow}
          width={isReverse ? windowSize[1] : windowSize[0]}
          autoSize={false}
          containerPadding={[0, 0]}
          margin={[0, 0]}
          layout={flow.layout}
          cols={flow.nbCol}
          innerRef={layoutRef}
          isDraggable={false}
          isResizable={false}
          isBounded={false}
        >
          {generateDOM()}
        </ReactGridLayout>
      </div>
    </div>
  )
}

export default RenderReactGrid
